(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-addresses"]) return;
  try {
    
  var newAddress = document.querySelector('.js-new-address');
  var newAddressModal = document.querySelector('.js-new-address-modal');
  var body = document.querySelector('body');
  var modal = document.querySelector('.c-addresses__fixed');
  var modalClose = document.querySelectorAll('.js-modal-close');

  newAddress.addEventListener('click', function(e) {
    e.preventDefault();
    newAddressModal.classList.add('is-active');
  });

  var editAddress = document.querySelectorAll('.js-edit-address');

  editAddress.forEach((edit) => {
    edit.addEventListener('click', function(e) {
      e.preventDefault();
      var addressId = this.getAttribute('data-address');
      var modal = document.querySelector(`.js-address-modal[data-modal="${addressId}"]`);
      modal.classList.add('is-active');
    });
  });

  modalClose.forEach((close) => {
    close.addEventListener('click', function(e) {
      e.preventDefault();
      var modal = this.closest('.c-modal');
      modal.classList.remove('is-active');
    });
  });


  class CustomerAddress {
    constructor() {
      this.initCustomerAddress();
      this.customerAddressesSelector();
      this.initDeleteAddressButtons();
    }

    initDeleteAddressButtons() {
      const deleteButtons = document.querySelectorAll('[data-delete-address]');

      if (deleteButtons.length < 1) return;

      deleteButtons.forEach((button) => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          let url = this.dataset.url;

          let confirmation = window.confirm("Are you sure you want to delete this address?");

          if (confirmation) {
            document.querySelector(`form[action="${url}"]`).submit();
          }
        });
      });
    }

    initCustomerAddress() {
      const allAddressesSelector = document.querySelectorAll('select[data-country-selector]');
      if (allAddressesSelector.length < 1) return;

      allAddressesSelector.forEach((select) => {
        let selectedCountry = this.getSelectedCountry(select);

        if(!selectedCountry) return;

        let provinces = selectedCountry.dataset.provinces;
        let arrayOfProvince = JSON.parse(provinces);

        let provinceSelector = document.querySelector(`#province_${select.dataset.id}`);

        if ( arrayOfProvince.length < 1 ) {
          provinceSelector.setAttribute('disabled', 'disabled');
        } else {
          provinceSelector.removeAttribute('disabled'); 
        }

        provinceSelector.innerHTML = '';


        let options = "";

        for (let i = 0; i < arrayOfProvince.length; i++) {
          if (arrayOfProvince[i][0] === provinceSelector.getAttribute('value')) {
            options += `<option value="${arrayOfProvince[i][0]}" selected>${arrayOfProvince[i][1]}</option>`;
          } else {
            options += `<option value="${arrayOfProvince[i][0]}">${arrayOfProvince[i][1]}</option>`;
          }
        }

        provinceSelector.innerHTML = options;
      });
    }

    getSelectedCountry(select) {
      let option, selectedOption;
      for (let i = 0; i < select.options.length; i++) {
        option = select.options[i];
        if (option.value === select.getAttribute('value')) {
          selectedOption = option;
          selectedOption.setAttribute('selected', 'selected');
          break;
        }
      }

      return selectedOption;
    }

    customerAddressesSelector() {
      const addressesSelector = document.querySelectorAll('select[data-country-selector]');

      if (addressesSelector.length < 1) return;

      addressesSelector.forEach((select) => {
        select.addEventListener('change', function(e) {
          let provinces = this.options[this.selectedIndex].dataset.provinces;
          let arrayOfProvince = JSON.parse(provinces);

          let provinceSelector = document.querySelector(`#province_${select.dataset.id}`);

          if ( arrayOfProvince.length < 1 ) {
            provinceSelector.setAttribute('disabled', 'disabled');
          } else {
            provinceSelector.removeAttribute('disabled'); 
          }

          provinceSelector.innerHTML = '';
          let options = "";

          for (let i = 0; i < arrayOfProvince.length; i++) {
            options += `<option value="${arrayOfProvince[i][0]}">${arrayOfProvince[i][1]}</option>`;
          }

          provinceSelector.innerHTML = options;
        });
      });
    }
  }

  const customerAddress = new CustomerAddress();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-article"]) return;
  try {
    
  document.querySelectorAll('.c-article__double-half').forEach(function(container) {
    const images = container.querySelectorAll('img');
    if (images.length > 1) {
      let current = 0;
      // Oculta totes les imatges excepte la primera
      images.forEach((img, i) => img.style.display = i === 0 ? 'block' : 'none');
      
      setInterval(function() {
        images[current].style.display = 'none';
        current = (current + 1) % images.length;
        images[current].style.display = 'block';
      }, 1500);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-collection"]) return;
  try {
    
  const relatedSection = document.querySelector('.c-collection__related');
  const relatedTrigger = document.querySelector('.js-related');
  if (relatedSection && window.matchMedia('(max-width: 768px)').matches) {
    relatedTrigger.addEventListener('click', () => {
      console.log('Related section clicked');
      relatedSection.classList.toggle('is-active');
      relatedTrigger.classList.toggle('is-active');
    });
  }

  var links = document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"])');

  function getTargetFromHash(hash) {
    if (!hash) return null;
    var id = decodeURIComponent(hash.slice(1));
    return document.getElementById(id) || document.querySelector('[name="' + id + '"]');
  }

  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var samePath = location.pathname.replace(/^\//, '') === link.pathname.replace(/^\//, '');
      var sameHost = location.hostname === link.hostname;
      if (!samePath || !sameHost) return;

      var target = getTargetFromHash(link.hash);
      if (!target) return;

      event.preventDefault();

      // Scroll nadiu i suau
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-favorites"]) return;
  try {
    

  /* function countUpdate() {
    setTimeout(() => {
      
    var count = document.querySelectorAll(".c-item").length;
      document.querySelector(".js-number-fav").innerHTML = count;
      document.querySelector('.js-number-block').classList.add('is-active');
    }, 1200);
  }

  


  
  countUpdate(); */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-home-new"]) return;
  try {
    
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // Hero video lazy-load via requestIdleCallback
  (function(){
    var heroVideo = document.querySelector('.c-home__video video.u-desktop');
    if (!heroVideo) return;
    function loadHeroVideo(){
      if(heroVideo.dataset.srcLoaded==='true') return;
      heroVideo.dataset.srcLoaded='true';
      heroVideo.querySelectorAll('source[data-src]').forEach(function(s){ s.src=s.dataset.src; });
      heroVideo.load();
      heroVideo.play().catch(function(){});
    }
    if('requestIdleCallback' in window){ requestIdleCallback(loadHeroVideo,{timeout:2000}); }
    else{ setTimeout(loadHeroVideo,1000); }
  })();

  

  var swiper = new Swiper('.swiper-other', {
    spaceBetween: 20,
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    loopedSlides: 6, // Specify number of slides to loop
    speed: 1000,
    grabCursor: true,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-nav-next',
      prevEl: '.swiper-nav-prev',
    },
    // Ensure loop works with auto slides
    on: {
      init: function () {
        this.update();
      },
      imagesReady: function () {
        this.update();
      }
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
        autoplay: false
      }
    }
  });

  // GSAP intro gated by sessionStorage
  const hasAnimation = sessionStorage.getItem('isAnimation') === 'true';

  if (!hasAnimation) {
    gsap.registerPlugin();
    let tl = gsap.timeline();

    if (window.innerWidth > 768) {
      tl.to(".js-span-1", { opacity: 1, duration: 0.6, ease: "sine.out" })
      .to(".js-span-2", { opacity: 1, duration: 0.7, ease: "sine.out" }, "<+=0.2")
      .to(".js-span-3", { opacity: 1, duration: 0.7, ease: "sine.out" }, ">+=0.1")
      .to(".js-span-4", { opacity: 1, duration: 0.8, ease: "sine.out" }, "<+=0.15")
      .to(".js-span-5", { opacity: 1, duration: 0.6, ease: "sine.out" }, "<+=0.25")
      .to(".js-span-6", { opacity: 1, duration: 0.7, ease: "sine.out" }, "<+=0.3")
      .to(".js-span-7", { opacity: 1, duration: 0.7, ease: "sine.out" }, "<+=0.2")
      .to(".js-span-8", { opacity: 1, duration: 0.8, ease: "sine.out" }, "<+=0.55")
      .to(".js-home-scroll", { opacity: 1, duration: 0.6, ease: "sine.out" }, "+=0.5")
      .call(() => {
        const clickEl = document.querySelector('.js-click');
        if (clickEl) clickEl.classList.add('is-done');
      });
    } else {
      tl.to(".js-span-1", { opacity: 1, duration: 0.6, ease: "sine.out" })
      .to(".js-span-4", { opacity: 1, duration: 0.7, ease: "sine.out" }, "<+=0.3")
      .to(".js-span-3", { opacity: 1, duration: 0.8, ease: "sine.out" }, "<+=0.25")
      .to(".js-span-1", { opacity: 0, duration: 0.6, ease: "sine.out" }, "+=0.8")
      .to(".js-span-3", { opacity: 0, duration: 0.6, ease: "sine.out" }, "<+=0.1")
      .to(".js-span-4", { opacity: 0, duration: 0.6, ease: "sine.out" }, "<+=0.1")
      .to(".js-home-scroll", { opacity: 1, duration: 0.6, ease: "sine.out" }, "+=0.5")
      .call(() => {
        gsap.to(".b-header__icons", { opacity: 1, duration: 0.6, ease: "sine.out" });
      });

    }

    
  } else {
    // Add is-animated class to body
    document.body.classList.add('is-animated');
    gsap.to(".b-header__menu, .b-header__icons", { opacity: 1, duration: 0.6, ease: "sine.out" });
    // Skip intro: set final state immediately
    const clickEl = document.querySelector('.js-click');
    if (clickEl && clickEl.parentNode) clickEl.parentNode.removeChild(clickEl);
  }

  // Click handler for fade out animation + set sessionStorage flag
  (function(){
    const trigger = document.querySelector('.js-click');
    if (!trigger) return;

    trigger.addEventListener('click', function() {
      if (!this.classList.contains('is-done')) return;

      document.body.classList.add('is-animated');
      // Mark that animation has already been seen this session
      try { sessionStorage.setItem('isAnimation', 'true'); } catch(e) {}

      const tl = gsap.timeline();
      tl.to(".js-home-scroll", { opacity: 0, duration: 0.6, ease: "sine.out" })
        .to(".b-header__menu", { opacity: 1, duration: 0.6, ease: "sine.out" }, "<")
        // Smooth scroll to #start after animations complete
        .call(() => {
          const target = document.getElementById('start');
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        })
        // Remove the .js-click element from the DOM
        .call(() => {
          if (this.parentNode) this.parentNode.removeChild(this);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-home"]) return;
  try {
    
  document.querySelectorAll('.js-half-trigger-1').forEach(trigger => {
    trigger.addEventListener('mouseenter', () => {
      document.querySelectorAll('.js-home-image').forEach(image => {
        image.classList.add('is-visible');
      });
    });

    trigger.addEventListener('mouseout', () => {
      document.querySelectorAll('.js-home-image').forEach(image => {
        image.classList.remove('is-visible');
      });
    });
  });

  var swiper = new Swiper('.swiper-home', {
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    autoplay: {
      delay: 3000,
    },
    loop: true,
    speed: 1000,

  });

  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-intro-new"]) return;
  try {
    
  const intro = document.querySelector(".c-intro");
	if (intro && window.innerWidth > 769) {
		if (localStorage.getItem("intro") === "seen") {
			intro.remove();
		} else {
			setTimeout(() => {
				intro.classList.add("is-hidden");
			}, 7000);
			localStorage.setItem("intro", "seen");
		}
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-login"]) return;
  try {
    
  document.querySelectorAll('.js-form-changer').forEach(link => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelectorAll('.c-form__form').forEach(form => {
        form.classList.toggle('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-other"]) return;
  try {
    
  var swiper = new Swiper('.swiper-other', {
    spaceBetween: 20,
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    loopedSlides: 6, // Specify number of slides to loop
    speed: 1000,
    grabCursor: true,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-nav-next',
      prevEl: '.swiper-nav-prev',
    },
    // Ensure loop works with auto slides
    on: {
      init: function () {
        this.update();
      },
      imagesReady: function () {
        this.update();
      }
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
        autoplay: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-poem"]) return;
  try {
    
  // Only run if window height is more than 768px
    // Image rotation functionality
    document.querySelectorAll('.js-poem-images').forEach(function(container) {
      const mediaElements = container.querySelectorAll(':scope > img, :scope > video');
      // Console log elements for debugging
      mediaElements.forEach((media, index) => {
        console.log(`Element ${index + 1}:`, media);
      });
      if (mediaElements.length > 1) {
      let current = 0;
      // Oculta tots els elements de mitjà excepte el primer
      mediaElements.forEach((media, i) => media.style.display = i === 0 ? 'block' : 'none');
      
      setInterval(function() {
      mediaElements[current].style.display = 'none';
      current = (current + 1) % mediaElements.length;
      mediaElements[current].style.display = 'block';
      }, 1500);
      } else if (mediaElements.length === 1) {
      mediaElements[0].style.display = 'block';
      }
    });

    // Cascading lines effect for poem title

    document.querySelectorAll('.js-poem-title').forEach(function(title, titleIndex) {
      // Skip if already processed
      if (title.classList.contains('js-cascading')) return;
      
      const html = title.innerHTML;
      if (html.includes('<br>')) {
        try {
          // Split by <br> tags and create spans for each line
          const lines = html.split('<br>');
          let totalWidth = 0;
          let newHTML = '';
          let lastLinePadding = 0;
          
          // Create temporary element with unique ID to measure width
          const measurementEl = document.createElement('div');
          measurementEl.id = 'poem-measure-' + titleIndex + '-' + Date.now();
          measurementEl.style.cssText = `
            position: absolute;
            visibility: hidden;
            white-space: nowrap;
            top: -9999px;
            left: -9999px;
            font-family: ${getComputedStyle(title).fontFamily};
            font-size: ${getComputedStyle(title).fontSize};
            font-weight: ${getComputedStyle(title).fontWeight};
          `;
          document.body.appendChild(measurementEl);
          
          lines.forEach(function(line, index) {
            const cleanLine = line.trim();
            if (cleanLine) {
              // Measure the width of the previous line
              if (index > 0) {
                measurementEl.textContent = lines[index - 1].trim();
                totalWidth += measurementEl.offsetWidth + 3;
              }
              
              newHTML += `<span class="poem-line" style="padding-left: ${totalWidth}px;">${cleanLine}</span>`;
              
              // Store the last line's padding for the transform
              lastLinePadding = totalWidth;
            }
          });
          
          // Clean up measurement element
          document.body.removeChild(measurementEl);
          
          // Apply the new HTML and add cascading class
          title.innerHTML = newHTML;
          title.classList.add('js-cascading');
          
          // Apply transform to shift the entire element left by the last line's padding

          title.style.transform = `translateX(-${lastLinePadding}px)`;
        
        } catch (error) {
          console.warn('Error processing poem title cascading effect:', error);
        }
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-product"]) return;
  try {
    
  const swiper = new Swiper('.swiper-product', {
    slidesPerView: 1,
    spaceBetween: 0,
    direction: 'vertical',
    autoplay: {
      delay: 3000,
    },
    loop: true,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });
document
  .querySelectorAll(".js-info-selector")
  .forEach(function (element, index) {
    // Expand first section on load
    if (index === 0) {
    const firstDescription = element.nextElementSibling;
    if (firstDescription && firstDescription.classList.contains('js-info-description')) {
      firstDescription.style.maxHeight = firstDescription.scrollHeight + 'px';
      firstDescription.style.opacity = '1';
      element.classList.add('is-expanded');
    }
    }
    
    element.addEventListener("click", function () {
    const description = this.nextElementSibling;
    
    if (description && description.classList.contains('js-info-description')) {
      const isCurrentlyOpen = description.style.maxHeight;
      
      // First, close all other sections
      document.querySelectorAll('.js-info-description').forEach(function(otherDescription) {
      const otherSelector = otherDescription.previousElementSibling;
      if (otherDescription !== description) {
        otherDescription.style.maxHeight = null;
        otherDescription.style.opacity = '0';
        if (otherSelector && otherSelector.classList.contains('js-info-selector')) {
        otherSelector.classList.remove('is-expanded');
        }
      }
      });
      
      // Then toggle the current section
      if (isCurrentlyOpen) {
      // Close current section
      description.style.maxHeight = null;
      description.style.opacity = '0';
      this.classList.remove('is-expanded');
      } else {
      // Open current section
      description.style.maxHeight = description.scrollHeight + 'px';
      description.style.opacity = '1';
      this.classList.add('is-expanded');
      }
    }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-register"]) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('create_customer');
  const submitButton = document.querySelector('.js-submit');
  const passwordField = document.querySelector('input[name="customer[password]"]');
  const passwordConfirmationField = document.querySelector('input[name="customer[password_confirmation]"]');

  // Check passwords on every input in the confirmation field
  passwordConfirmationField.addEventListener('input', function () {
    const password = passwordField.value;
    const passwordConfirmation = passwordConfirmationField.value;

    if (password === passwordConfirmation) {
      submitButton.classList.remove('is-inactive');
    } else {
      submitButton.classList.add('is-inactive');
    }
  });

  // Original submit event listener
  form.addEventListener('submit', function (e) {
    const password = passwordField.value;
    const passwordConfirmation = passwordConfirmationField.value;

    if (password !== passwordConfirmation) {
      e.preventDefault();
      alert('Passwords do not match.');
    }
  });
});




  } catch(e) { console.error(e); }
})();
})();
